import { render } from "./UserModelDialog.vue?vue&type=template&id=06a88f7d&scoped=true"
import script from "./UserModelDialog.vue?vue&type=script&lang=js"
export * from "./UserModelDialog.vue?vue&type=script&lang=js"

import "./UserModelDialog.vue?vue&type=style&index=0&id=06a88f7d&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a88f7d"]])

export default __exports__